import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import styles from './styles'
import { CoreButton } from 'src/components/core'
const BackButton = props => {
  const { classes, handleBackToHome } = props

  return (
    <div className={classes.backButton} onClick={() => handleBackToHome()}>
      <CoreButton variant="text" color="dark" startIcon={<ChevronLeftIcon />}>
        Back
      </CoreButton>
    </div>
  )
}

export default withStyles(styles)(BackButton)
